// Access belongs to the tab whose token/userId it accompanies. localStorage is
// shared by every tab and cannot safely restore permissions for this identity.
export const SESSION_ACCESS_KEY = '@analytics/session-access-v1';
const accessFields = ['userProfile', 'userOrchard', 'moduleUser', 'userClient', 'userSpecies'];
const identityFields = ['token', 'userId', 'userName', 'userLastname', 'userFullname', 'userIdProfile', 'initialRoute'];

const emptySession = () => Object.fromEntries(
  [...identityFields, ...accessFields].map(field => [field, null])
);

export function readSessionAccess() {
  try {
    const token = sessionStorage.getItem('token');
    const userId = sessionStorage.getItem('userId');
    const access = JSON.parse(sessionStorage.getItem(SESSION_ACCESS_KEY));
    if (!token || !userId || access?.version !== 1 || access.userId !== userId ||
        !Array.isArray(access.moduleUser)) return emptySession();
    return {
      ...Object.fromEntries(identityFields.map(field => [field, sessionStorage.getItem(field)])),
      ...Object.fromEntries(accessFields.map(field => [field, access[field] ?? null])),
    };
  } catch {
    // Corrupt/legacy/unavailable storage requires login, never grants access.
    return emptySession();
  }
}

export function saveSessionAccess(access) {
  sessionStorage.setItem(SESSION_ACCESS_KEY, JSON.stringify({
    version: 1,
    userId: access.userId,
    ...Object.fromEntries(accessFields.map(field => [field, access[field] ?? null])),
  }));
}

export function clearSessionAccess() {
  sessionStorage.removeItem(SESSION_ACCESS_KEY);
}
